import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Box, Divider } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { CountEntry } from "routes/regime/plugins/zero-u-wizard/count-entry"
import { useState } from "react"
import { Bound } from "lib/@components/binding/Bound"
import { useRefresh } from "lib/@hooks/useRefresh"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { createPortal } from "react-dom"
import { Frag } from "lib/@components/slot/frag"
import { Tailor0U } from "routes/regime/plugins/zero-u-wizard/tailor0-u"
import { TailoredLabel } from "routes/regime/plugins/zero-u-wizard/tailored-label"

export function Tailorable({ item, last, onlyOne, masterCount }) {
    const { currentTitles, portal } = useBoundContext()
    const schedule = currentTitles.schedule?.title === item.schedule.title ? "-" : item.schedule.title
    const skill = currentTitles.skill === item.skill ? "-" : item.skill
    const [target] = useState(() => createInitialTarget(item))
    const refresh = useRefresh()

    return (
        <Bound target={target} refresh={refresh} editMode task={target}>
            <ListItemBox data-cy="tailorable-row" spacing={3}>
                <Box width={1 / 4} />
                <Box width={1 / 5} maxWidth={160}>
                    <ListItemBox spacing={2}>
                        <TailoredLabel>{skill}</TailoredLabel>

                        <Box flex={1} />
                        {schedule === "-" && (
                            <CountEntry
                                task={item.task}
                                skill={skill}
                                schedule={schedule !== "-" && item.schedule._id}
                                showOne
                                count={skill !== "-" && item.count}
                                frequencyPeriod={item.frequencyPeriod}
                                frequencyInterval={item.frequencyInterval}
                                minutes={item.minutes}
                            />
                        )}
                    </ListItemBox>
                </Box>
                <Box width={1 / 4}>
                    <ListItemBox spacing={2}>
                        <TailoredLabel navigateTo={item.taskObject.scheduleId} append={`#${item.schedule.code}`}>
                            {schedule}
                        </TailoredLabel>
                        <Box flex={1} />
                        <CountEntry
                            task={item.task}
                            skill={skill}
                            schedule={schedule !== "-" && item.schedule._id}
                            showOne
                            count={schedule !== "-" && item.count}
                            frequencyPeriod={item.frequencyPeriod}
                            frequencyInterval={item.frequencyInterval}
                            minutes={item.minutes}
                        />
                    </ListItemBox>
                </Box>
                <Box flex={1}>
                    <If truthy={onlyOne}>
                        <Frag>
                            {!!portal &&
                                createPortal(
                                    <Tailor0U
                                        task={item.task}
                                        skill={skill}
                                        count={masterCount}
                                        schedule={schedule !== "-" && item.schedule._id}
                                    />,
                                    portal
                                )}
                        </Frag>
                        <Else>
                            <Tailor0U
                                task={item.task}
                                skill={skill !== "-" && skill}
                                schedule={schedule !== "-" && item.schedule._id}
                                count={item.count}
                            />
                        </Else>
                    </If>
                </Box>
            </ListItemBox>
            {!last && <Divider sx={{ mx: -2 }} />}
        </Bound>
    )
}

function createInitialTarget(item) {
    const frequency = item?.taskObject?.frequency ?? {}
    return {
        frequency: {
            period: frequency.period ?? "Unknown",
            interval: frequency.interval ?? 0,
            label: frequency.label,
        },
        minutes: item?.taskObject?.minutes ?? 0,
    }
}
